import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-basic-content',
  styleUrls: ['./basic-content.component.scss'],
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicContentComponent {}
